import { useCallback } from 'react';

import useFromEvent from './useFromEvent';

const useBeforeUnload = () => {
  const fromEvent = useFromEvent();

  return useCallback(
    (handleBeforeUnload: (e?: BeforeUnloadEvent) => void) =>
      fromEvent(window, 'beforeunload').subscribe(handleBeforeUnload),
    [fromEvent]
  );
};
export default useBeforeUnload;
